const isProduction = window.themeVariables?.environment?.isProduction || "";
const updateBookingUrl = (variantId) => {
  const submitButton = document.querySelector(".block-item-spa-variant-picker + .block-item-button");
  if(!submitButton) return;

  const { blockFunnelBaseUrl, blockServiceFamily, blockProductTitle } = submitButton.dataset;

  let constructedUrl = blockFunnelBaseUrl;
  constructedUrl += `serviceFamily=${blockServiceFamily}`;
  constructedUrl += `&title=${blockProductTitle}`;

  if (variantId) {
    constructedUrl += `&variant=${variantId}`;
    submitButton.classList.remove('hidden')
  } else {
    submitButton.classList.add('hidden')
  }

  submitButton.querySelector("a").href = constructedUrl;
}
function spaVariantPicker() {
  const allFieldsets = document.querySelectorAll("[data-step]");
  const anchor = document.querySelector("a[href='#spa-variant-picker']");

  const updatesVisibilityFields = () => {
    console.log("updateVisibility");
    allFieldsets.forEach(fieldset => {
      const checkedOption = fieldset.querySelector('input[type="radio"]:checked:not(.spa-hidden-input)');
      console.log('checkedOption = ', checkedOption)
      if(!checkedOption) return;
      if (checkedOption) {
        fieldset.classList.add('checked')
      } else {
        fieldset.classList.remove('checked')
      }
    });
  };
  const storeVariantPickerData = () => {
    const selectedFields = {};
    console.log('allFieldsets', allFieldsets);
    const keyName = (textContent) => {
      if (!textContent) return 'unknown';
      const lowerCaseText = textContent.toLowerCase();

      if (lowerCaseText.includes('min') || lowerCaseText.includes('flash') || lowerCaseText.includes('expert')) {
        return 'duration';
      } else if (lowerCaseText.includes('solo') || lowerCaseText.includes('duo')) {
        return 'participants';
      } else {
        return 'unknown';
      }
    };
    allFieldsets.forEach(fieldset => {
      const checkedOption = fieldset.querySelector('input[type="radio"]:checked:not(.spa-hidden-input)');
      if (checkedOption) {
        const textContent = checkedOption.nextElementSibling?.textContent || '';
        if(textContent) {
          const key = keyName(textContent);
          if(key !== 'unknown') {
            selectedFields[key] = textContent;
          }
        }

      }
    });
    if(selectedFields) {
      localStorage.setItem('booking-pdp', JSON.stringify(selectedFields));
    }
  }

  anchor?.addEventListener("click", (e) => {
    // console.log(parseInt(selectFieldStep1.offsetTop + window.innerHeight + (productGalleryHeight / 2)));
    const safeSticky = e.target.closest("safe-sticky");
    const productGallery = safeSticky.previousElementSibling;
    const stickyHeight = (safeSticky.offsetHeight < productGallery.offsetHeight) ? (productGallery.offsetHeight - safeSticky.offsetHeight) : 0;
    const spaVariantPicker = document.getElementById("spa-variant-picker");
    const header = document.querySelector("header.shopify-section--header");
    const headerHeight = header ? header.offsetHeight : 0;
    const offsetTopDesktop =  spaVariantPicker.offsetTop + stickyHeight + headerHeight + 46;

    console.log(window.innerWidth < 1000)
    console.log(spaVariantPicker.offsetTop)
    e.preventDefault();
    window.scrollTo({
      top: (window.innerWidth < 1000) ? (spaVariantPicker.getBoundingClientRect().top + window.scrollY - headerHeight) : offsetTopDesktop,
      left:0,
      behavior: "smooth"
    });
  });
  if(window.location.search.includes('variant')) {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get("variant");
    updateBookingUrl(variantId)
  }

  updatesVisibilityFields()

  storeVariantPickerData()
}
document.addEventListener("DOMContentLoaded", () => {
  // Uncheck default radio on load if no variant in url
  const allFieldsets = document.querySelectorAll("[data-step]");
  const submitBtn = document.querySelector('.block-item-spa-variant-picker + .block-item-button');

  if(!window.location.search.includes('variant')) {
    if(submitBtn) {
      submitBtn.classList.add('hidden');
    }

    allFieldsets.forEach((fieldset, index) => {
      if(index > 0) {
        const radioBtns = fieldset.querySelectorAll('input[type="radio"].sr-only');

        radioBtns.forEach((radio) => {
          if(!radio.parentElement.querySelector('.is-disabled')) {
            radio.checked = false;
            fieldset.classList.remove('checked')
          }
        });
      }
    })
  }
  const spaVariantPickerElement = document.querySelector('.block-item-spa-variant-picker')
  if(spaVariantPickerElement) {
    spaVariantPicker()
  }
});

const form = document.querySelector('.shopify-product-form');
if(form){
  form.addEventListener('product:rerender', (e) => {
    if(e.detail.variant) {
      updateBookingUrl(e.detail.variant.id)
    }

    spaVariantPicker()
  });
}



function returnUrl() {
  const elts = document.getElementsByClassName('return_url')
  if (elts && elts.length > 0) {
    // disable login return_url input hidden
    document.querySelectorAll('input[type="hidden"][name="return_url"]').forEach(input => {
      input.disabled = true;
    });

    let return_url = new URLSearchParams(window.location.search).get('return_url') || ''
    // Remove everything after ? (parameters) and # (fragments)
    const pathOnly = return_url.split(/[?#]/)[0];

    // Remove trailing slash if present (except for root)
    const cleanPath = pathOnly.endsWith('/') && pathOnly !== '/'
        ? pathOnly.slice(0, -1)
        : pathOnly;
    if (cleanPath.endsWith('/account')) {
      return_url  = "";
    }

    if (return_url.length > 0) {
      Array.from(elts).forEach(elt => {
        elt.value = return_url
      })
    }
  }
}
document.addEventListener("DOMContentLoaded", () => returnUrl());

/** START : ACCOUNT GIFTCARDS */
function fillServiceCardDetails(data) {
  document.querySelector("#account-giftcards .info .content").textContent = `${data.center?.address1} ${data.center?.zip_code} ${data.center?.city}`;
  document.querySelector("#account-giftcards .time").textContent = `${data.service?.duration - data.service?.recovery_time}min`;
  document.querySelector("#account-giftcards .participant").textContent = data.service?.is_couple_service ? 'Duo' : 'Solo';

  if(data.giftCard?.is_closed) {
    document.querySelector("#account-giftcards .closed").classList.add("active");
  } else if(new Date() > new Date(data.giftCard?.expiry_date)) {
    document.querySelector("#account-giftcards .expired").classList.add("active");
  } else {
    const currentLang = document.documentElement.lang || "default";
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const formattedDate = new Date(data.giftCard?.expiry_date).toLocaleDateString(currentLang, options);
    const elm = document.querySelector("#account-giftcards .card.service .date");
    elm.classList.add("active");
    elm.querySelector(".value").textContent = formattedDate;
  }
}

function fillAmountCardDetails(data) {
  const formattedAmount = data.giftCard?.balance?.toLocaleString('default', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  document.querySelector("#account-giftcards .card.gift .amount").textContent = `${formattedAmount}€`;

  const options = { day: "2-digit", month: "long", year: "numeric" };
  const currentLang = document.documentElement.lang || "default";
  const formattedDate = new Date(data.giftCard?.expiry_date).toLocaleDateString(currentLang, options);
  const elm = document.querySelector("#account-giftcards .card.gift .date");
  elm.classList.add("active");
  elm.querySelector(".value").textContent = formattedDate;
}

function displayGiftCardResult(data) {
  if (!data.giftCard) {
    const resultContainer = document.querySelector("#account-giftcards .error");
    resultContainer?.classList.add("active");
    return;
  }

  if(data.giftCard?.type === 2) {
    document.querySelector("#account-giftcards .card.service")?.classList.add("active");
    document.querySelector("#account-giftcards .card.gift")?.classList.remove("active");
    fillServiceCardDetails(data);
  } else {
    document.querySelector("#account-giftcards .card.gift")?.classList.add("active");
    document.querySelector("#account-giftcards .card.service")?.classList.remove("active");
    fillAmountCardDetails(data);
  }
}

function getShopifyData(zenotiData) {
  const payload = JSON.stringify({
    query: `query GetCentersAndProducts($language: LanguageCode) @inContext(language: $language) {
      collectionByHandle(handle: "soins") {
        products(first:100) {
          edges {
            node {
              title
              variants(first: 50) {
                edges {
                  node {
                    title
                    metafield(namespace: "custom", key: "id_pms") {
                      value
                    }
                  }
                }
              }
              centersList: metafield(namespace: "custom", key: "liste_de_spas") {
                references(first: 100) {
                  edges {
                    node {
                      ... on Metaobject {
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
    variables: {
      language: document.documentElement.lang.toUpperCase(),
    }
  });

  fetch(window.themeVariables.environment.variables.graphql_url,
    {
      method: 'POST',
      body: payload,
      headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.themeVariables.environment.variables.shopify_storefront_token,
      },
    }
  ).then(response => response.json())
  .then(data => {
    const products = data.data?.collectionByHandle?.products?.edges;
    let titleSpa;

    products.forEach(product => {
      product.node?.centersList?.references?.edges?.forEach(center => {
        center.node?.fields?.filter(field => {
          if (field.key === 'id_center' && field.value === zenotiData.center?.code.split('-')[0]) {
            titleSpa = center.node?.fields?.find(field => field.key === 'nom_du_spa')?.value;

            const name = center.node?.fields?.find(field => field.key === 'spa_dermo_ocean_spa_deep_ocean_spa')?.value;
            const link = center.node?.fields?.find(field => field.key === 'lien_map')?.value;
            document.querySelector("#account-giftcards .info .name").textContent = name;
            document.querySelector("#account-giftcards .info").setAttribute('href', link);
          }
        });
      });

      product.node?.variants?.edges?.forEach(variant => {
        if(variant.node.metafield?.value === zenotiData.service?.code && variant.node.title.includes(titleSpa)) {
          document.querySelector("#account-giftcards .title").textContent = product.node.title;
        }
      });
    });
  }).catch(error => console.error("Error fetching shopify center data:", error));
 }

function giftcardCodeSubmit() {
  const input = document.getElementById("input-giftcard");
  const giftCardCode = input ? input.value.trim() : '';
  const errorMessage = document.querySelector("#account-giftcards .error");

  errorMessage?.classList.remove("active");
  document.querySelectorAll("#account-giftcards .card")?.forEach(card => card.classList.remove("active"));

  if (!giftCardCode) return;

  const loader = document.getElementById("account-giftcards-loader");
  loader?.classList.add("active");

  fetch(`${window.themeVariables.environment.variables.bff_url}/pms/giftcards/${giftCardCode}`, {
    method: "GET",
    headers: {
      "shopify-edge-metadata-shop-id": window.themeVariables.environment.variables.shopify_shop_id,
      "ngrok-skip-browser-warning": window.themeVariables.environment.variables.ngrok_skip_warning,
    },
  })
  .then(response => response.json())
  .then(data => {
    loader?.classList.remove("active");
    displayGiftCardResult(data);
    getShopifyData(data);
  }).catch(error => {
    console.error("Error fetching giftcard data:", error);
    loader?.classList.remove("active");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector("#giftcard-search .button")?.addEventListener("click", (e) => {
    e.preventDefault();
    giftcardCodeSubmit();
  });

  document.querySelector("#giftcard-search .input-clear-button")?.addEventListener("click", () => {
    const input = document.getElementById("input-giftcard");
    if (input) {
      input.value = "";
    }
  });
});
/** END : ACCOUNT GIFTCARDS */

/** START : ACCOUNT BOOKINGS */
function countPastBookings() {
  const pastBookingBlock = document.getElementById("account-booking-past");
  const pastBookingItems = document.querySelectorAll("#account-booking-past .account-bookings__card.active");
  const pastBookingTitle = document.querySelector("#account-booking-past .title");

  if (pastBookingItems?.length > 0) {
    const pastBookingsCount = pastBookingItems.length;
    const content = pastBookingTitle?.textContent;

    pastBookingTitle.textContent = `${content} (${pastBookingsCount})`;
    pastBookingBlock?.classList.add("active");
  } else {
    pastBookingBlock?.classList.remove("active");
  }
}

function countFutureBookings() {
  const futureBookingBlock = document.getElementById("account-booking-future");
  const futureBookingItems = document.querySelectorAll("#account-booking-future .account-bookings__card.active");
  const futureBookingTitle = document.querySelector("#account-booking-future .title");

  if (futureBookingItems?.length > 0) {
    const futureBookingsCount = futureBookingItems.length;
    const content = futureBookingTitle?.textContent;

    futureBookingTitle.textContent = `${content} (${futureBookingsCount})`;
    futureBookingBlock?.classList.add("active");
  } else {
    futureBookingBlock?.classList.remove("active");
  }
}

function dispatchCards() {
  const allCards = document.querySelectorAll(".account-bookings__card.active");

  allCards?.forEach(card => {
    const appointmentDate = card.querySelector(".account-bookings__date")?.dataset.date;

    if (appointmentDate && new Date(appointmentDate) > new Date()) {
      document.getElementById("account-booking-future").classList.add("active");
      document.getElementById("account-booking-future").appendChild(card);
    }
  });
}

function sortCardsByDate() {
  const futureContainer = document.getElementById("account-booking-future");
  const pastContainer = document.getElementById("account-booking-past");

  if (futureContainer) {
    const futureCards = Array.from(futureContainer.querySelectorAll(".account-bookings__card.active"));
    futureCards.sort((a, b) => {
      const dateA = new Date(a.querySelector(".account-bookings__date").dataset.date);
      const dateB = new Date(b.querySelector(".account-bookings__date").dataset.date);
      return dateA - dateB;
    });
    futureCards.forEach(card => futureContainer.appendChild(card));
  }

  if (pastContainer) {
    const pastCards = Array.from(pastContainer.querySelectorAll(".account-bookings__card.active"));
    pastCards.sort((a, b) => {
      const dateA = new Date(a.querySelector(".account-bookings__date")?.dataset.date);
      const dateB = new Date(b.querySelector(".account-bookings__date")?.dataset.date);
      return dateB - dateA;
    });
    pastCards.forEach(card => pastContainer.appendChild(card));
  }
}

function handlePagination() {
  const cardsPerPage = 10;
  const container = document.getElementById("account-booking-past");
  const cards = container.querySelectorAll(".account-bookings__card.active");
  const totalCards = cards.length;
  const totalPages = Math.ceil(totalCards / cardsPerPage);
  const paginationWrapper = document.querySelector(".account-bookings__pagination");
  const paginationPrev = paginationWrapper.querySelector(".pagination-nav.prev");
  const paginationNext = paginationWrapper.querySelector(".pagination-nav.next");
  const paginationList = paginationWrapper.querySelector(".pagination-list");

  if (totalPages <= 1) return;

  // show pagination
  paginationWrapper.classList.add("active");
  paginationNext.classList.add("active");

  // pagination navigation
  paginationPrev.addEventListener("click", () => {
    const activeButton = paginationWrapper.querySelector(".pagination-button.active");
    if (activeButton && activeButton.previousSibling) {
      activeButton.previousSibling.click();
    }
  });

  paginationNext.addEventListener("click", () => {
    const activeButton = paginationWrapper.querySelector(".pagination-button.active");
    if (activeButton && activeButton.nextSibling) {
      activeButton.nextSibling.click();
    }
  });

  // create pagination items buttons
  for (let i = 1; i <= totalPages; i++) {
    const pageButton = document.createElement("button");
    pageButton.textContent = i;
    pageButton.className = "pagination-button";

    // default active page
    if (i === 1) {
      pageButton.classList.add("active");
      pageButton.setAttribute("aria-current", "page");
    }

    // click on items buttons
    pageButton.addEventListener("click", () => {
      container.querySelectorAll(".account-bookings__card.active").forEach((card, index) => {
        card.style.display = (index >= (i - 1) * cardsPerPage && index < i * cardsPerPage) ? "block" : "none";
      });

      if (i > 1) {
        paginationPrev.classList.add("active");
      } else {
        paginationPrev.classList.remove("active");
      }
      if (i < totalPages) {
        paginationNext.classList.add("active");
      } else {
        paginationNext.classList.remove("active");
      }

      paginationWrapper.querySelectorAll(".pagination-button").forEach(btn => btn.classList.remove("active"));
      pageButton.classList.add("active");
      pageButton.setAttribute("aria-current", "page");
      window.scrollTo({ top: container.offsetTop - 100});
    });

    paginationList.appendChild(pageButton);
  }

  // init display cards
  container.querySelectorAll(".account-bookings__card.active").forEach((card, index) => {
    card.style.display = (index < cardsPerPage) ? "block" : "none";
  });
}

function getBookingDate() {
  const cards = document.querySelectorAll(".account-bookings__card.active");

  cards?.forEach(card => {
    const date = card.querySelector(".account-bookings__date")?.dataset.date;

    if (!date) return;

    const currentLang = document.documentElement.lang || "default";
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString(currentLang, options);
    const hours = new Date(date).getHours().toString().padStart(2, "0");
    const minutes = new Date(date).getMinutes().toString().padStart(2, "0");
    const time = currentLang === "fr" ? `${hours}h${minutes}` : new Date(date).toLocaleTimeString(currentLang, { hour: "2-digit", minute: "2-digit" });

    card.querySelector(".account-bookings__date").setAttribute("data-date", date);
    card.querySelector(".account-bookings__date .date").textContent = formattedDate;
    card.querySelector(".account-bookings__date .hour").textContent = time;
  });
}

function generateCards(data) {
  const templateCard = document.querySelector(".account-bookings__template");

  data?.past?.concat(data?.future || [])?.forEach(appointment => {
    const card = templateCard?.cloneNode(true);
    card?.classList.remove("account-bookings__template");
    card?.classList.add("active");

    // fill with data
    const priceTemplateText = card?.querySelector(".account-bookings__price")?.textContent;
    const currency = priceTemplateText?.slice(-1);
    const appointmentCenter = data.centers?.filter(center => center.centerId === appointment.center_id)[0];
    card.querySelector(".account-bookings__price").textContent = `${(appointment.price?.final * (appointment.no_of_guests || 1)).toLocaleString('default', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) || ''}${currency}`;
    card.querySelector(".account-bookings__participant").textContent = appointment.no_of_guests === 1 ? 'Solo' : 'Duo';
    card.querySelector(".account-bookings__guest").textContent = `${appointment?.guest?.last_name} ${appointment?.guest?.first_name}`;
    card.querySelector(".account-bookings__date").dataset.date = appointment.appointment_services[0]?.start_time || '';
    card.querySelector(".account-bookings__duration").textContent = `${data.services?.[appointment?.appointment_services[0]?.service?.id]?.duration || ''} min`;
    card.querySelector(".account-bookings__name").textContent = data.services?.[appointment?.appointment_services[0]?.service?.id]?.name || '';
    card.querySelector(".account-bookings__phone").textContent = appointmentCenter?.phone || '';
    card.querySelector(".account-bookings__link").textContent = `${appointmentCenter?.name || ''} ${appointmentCenter?.address || ''}`;
    card.querySelector(".account-bookings__link").setAttribute("href", appointmentCenter?.mapLink || '#');
    card.querySelector(".account-bookings__mail").textContent = appointmentCenter?.mail || '';
    card.querySelector(".account-bookings__mail").setAttribute("href", `mailto:${appointmentCenter?.mail || '#'}`);

    // append to the right container
    if (new Date(appointment.appointment_services[0]?.start_time) > new Date()) {
      document.getElementById("account-booking-future").appendChild(card);
    } else {
      document.getElementById("account-booking-past").appendChild(card);
    }
  });
}

function getZenotiAppointments() {
  // guestId is only needed for local env.
  // To get your guestId, do a booking on prod and then check the network tab on reserve request. In the response, you will see the guest_id value to replace below.
  const guestId = "189f9e60-1adb-4163-a4c9-96b504d36580";
  const query = window.location.origin === "http://127.0.0.1:9292" ?
  `http://127.0.0.1:9292/apps/pms/guests/appointments` :
  `${window.themeVariables.environment.variables.bff_url}/pms/guests/appointments`

  const loader = document.getElementById("account-bookings-loader");
  loader?.classList.add("active");

  fetch(query, {
    method: "GET",
    headers: {
      "shopify-edge-metadata-shop-id": window.themeVariables.environment.variables.shopify_shop_id,
      "ngrok-skip-browser-warning": window.themeVariables.environment.variables.ngrok_skip_warning,
    },
  })
  .then(response => response.json())
  .then(data => {
    loader?.classList.remove("active");

    generateCards(data);

    // hide empty category blocks
    if ((data?.past?.length === 0 && data?.future?.length === 0) || !data.past) {
      document.getElementById("account-no-booking")?.classList.add("active");
    }

    // on account bookings template, init bookings display
    if (document.getElementById("account-bookings")) {
      if (data?.future?.length === 0) {
        document.getElementById("account-booking-future").classList.remove("active");
      }
      if (data?.past?.length === 0) {
        document.getElementById("account-booking-past").classList.remove("active");
      }

      getBookingDate();
      accountBookings();
    }
  }).catch(error => {
    loader?.classList.remove("active");
    console.error("Error fetching appointments:", error);
  });
}

function accountBookings() {
  dispatchCards();
  sortCardsByDate();
  handlePagination();
  countPastBookings();
  countFutureBookings();
}

document.addEventListener("DOMContentLoaded", async() => {
  if (document.querySelector("#account-bookings")) {
    await getZenotiAppointments();
  }
});
/** END : ACCOUNT BOOKINGS */

/** START : REMOVING TIME EXPIRED SERVICES FROM CART */

function getCartData(shopifyId, reservationId) {
  const simplifiedShopifyId = parseInt(shopifyId.split('ProductVariant/')[1]);

  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const cartItemToRemove = data?.items.filter(item => item.variant_id === simplifiedShopifyId);
      if (cartItemToRemove.length > 0) {
        localStorage.setItem(`cartLine-${reservationId}`, JSON.stringify(cartItemToRemove[0]));
      }
    }).catch(error => console.error('Error fetching cart:', error));
}

function launchTimer() {
  setTimeout(() => {
    const booking = JSON.parse(localStorage.getItem('booking-storage'));
    if (booking?.zenotiReservations?.length > 0) {
      const lastReservation = booking.zenotiReservations[booking.zenotiReservations.length - 1];
      const zenotiId = lastReservation?.invoices[0]?.items[0]?.item?.id;
      const variants = booking?.currentServiceVariants;
      const shopifyId = variants.find(variant => {
        return variant.zenotiId === zenotiId ? variant.shopify : null;
      })?.shopify;
      const reservationId = `${lastReservation?.booking_id}_${Date.now()}`;

      getCartData(shopifyId, reservationId);
      startCountdownTimer(reservationId, 1800000); // 1800000 = 30min
    }
  }, 1000);
}

function createInterval(timerKey, reservationId) {
  setInterval(() => {
    const remaining = localStorage.getItem(timerKey) - new Date().getTime();

    if (remaining <= 0) {
      if (localStorage.getItem(timerKey)) {
        localStorage.removeItem(timerKey);
        localStorage.removeItem(`${timerKey}_reservationId`);
        removeItemFromCart(reservationId);
      }
      clearInterval();
    }
  }, 1000);
}

function startCountdownTimer(reservationId, duration) {
  const timerKey = `timer_${reservationId}`;
  const endTime = new Date().getTime() + duration;

  localStorage.setItem(timerKey, endTime);
  localStorage.setItem(`${timerKey}_reservationId`, reservationId);
  createInterval(timerKey, reservationId);
}

function checkExistingTimer() {
  const allKeys = Object.keys(localStorage);
  const timerKeys = allKeys.filter(key => key.startsWith('timer_') && !key.includes('_reservationId'));

  timerKeys.forEach(timerKey => {
    const endTime = parseInt(localStorage.getItem(timerKey));
    const reservationId = localStorage.getItem(`${timerKey}_reservationId`);

    if (endTime && reservationId) {
      const remaining = endTime - new Date().getTime();

      if (remaining > 0) {
        createInterval(timerKey, reservationId);
      } else {
        if (localStorage.getItem(timerKey)) {
          localStorage.removeItem(timerKey);
          localStorage.removeItem(`${timerKey}_reservationId`);
          removeItemFromCart(reservationId);
        }
      }
    }
  });
}

function removeItemFromCart(reservationId) {
  const cartLine = localStorage.getItem(`cartLine-${reservationId}`);
  const id = cartLine ? JSON.parse(cartLine).key : null;

  if (cartLine) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'id': id,
        'quantity': 0
      })
    })
    .then(response => {
      localStorage.removeItem(`cartLine-${reservationId}`);
      return response.json();
    })
    .catch((error) => {
      console.error('Error fetching cart update:', error);
    });
    document.dispatchEvent(new Event('cart:change'))
  }
}

document.addEventListener('DOMContentLoaded', () => checkExistingTimer());
document.addEventListener("newReservation", () => launchTimer());
document.addEventListener('DOMContentLoaded', () => console.log('Custom scripts loaded'));
/** END : REMOVING TIME EXPIRED SERVICES FROM CART */

//Relocate the link "Mes informations" added by Helium apps
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const editLink = document.querySelector(".cf-edit-account-link");
    if (!editLink) return;

    const currentLi = editLink.closest("li");
    if (!currentLi) return;

    const newLi = document.createElement("li");

    newLi.appendChild(editLink);

    currentLi.parentNode.insertBefore(newLi, currentLi.nextSibling);
  }, 100)
});

function setupHomeHero() {
  const homeHero = document.querySelector(".home-hero");
  let firstVideo, lastVideo;

  function callback(mutationsList) {
    mutationsList.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        if(!document.querySelector('.places.has-error') && !document.querySelector('.select-service.has-error') && !document.querySelector('.select-mode.has-error')){
          firstVideo.classList.remove("error-dimmed");
          lastVideo.classList.remove("error-dimmed");
        }
      }
    })
  }

  if (homeHero) {
    firstVideo = homeHero.querySelector(".view:nth-of-type(1) video");
    lastVideo = homeHero.querySelector(".view:nth-of-type(2) video");

    firstVideo.addEventListener("mouseenter", () => {
      lastVideo.pause();
      lastVideo.classList.add("dimmed");
    })

    firstVideo.addEventListener("mouseleave", (e) => {
      if (e.toElement) {
        if (e.toElement.className === "hero-cta") {
          return;
        }
      }

      lastVideo.play();
      lastVideo.classList.remove("dimmed");
    })

    lastVideo.addEventListener("mouseenter", () => {
      firstVideo.pause();
      firstVideo.classList.add("dimmed");
    })

    lastVideo.addEventListener("mouseleave", (e) => {
      if (e.toElement) {
        if (e.toElement.className === "hero-cta") {
          return;
        }
      }

      firstVideo.play();
      firstVideo.classList.remove("dimmed");
    })

    if(window.innerWidth >= 1000) {
      const placesHasError =document.querySelector('.places.has-error');
      const selectServiceHasError =document.querySelector('.select-service.has-error');
      const selectModeHasError =document.querySelector('.select-mode.has-error');

      document.querySelector('.booking-button button')?.addEventListener('click', (e) => {
        if(placesHasError || selectServiceHasError || selectModeHasError){
          firstVideo.classList.add("error-dimmed");
          lastVideo.classList.add("error-dimmed");
        }

        const mutationObserver = new MutationObserver(callback)
        if (placesHasError) {
          mutationObserver.observe(placesHasError, { attributes: true });
        }
        if (selectServiceHasError) {
        mutationObserver.observe(selectServiceHasError, { attributes: true });
        }
        if (selectModeHasError) {
        mutationObserver.observe(selectModeHasError, { attributes: true });
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', () => setupHomeHero());

function getServiceIdFromShopify(variantId, titleProduct) {
  const payload = JSON.stringify({
    query: `query GetCentersAndProducts($language: LanguageCode) @inContext(language: $language) {
      collectionByHandle(handle: "toutes-nos-invitations-cadeaux") {
        products(first:100) {
          edges {
            node {
              title
              id
              variants(first: 50) {
                edges {
                  node {
                    id
                    title
                    priceV2 {
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                    metafield(namespace: "custom", key: "id_pms") {
                      value
                    }
                  }
                }
              }
              centersList: metafield(namespace: "custom", key: "liste_de_spas") {
                references(first: 100) {
                  edges {
                    node {
                      ... on Metaobject {
                        handle
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
    variables: {
      language: document.documentElement.lang.toUpperCase(),
    }
  });

  fetch(window.themeVariables.environment.variables.graphql_url,
    {
      method: 'POST',
      body: payload,
      headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.themeVariables.environment.variables.shopify_storefront_token,
      },
    }
  ).then(response => response.json())
  .then(data => {
    const products = data.data?.collectionByHandle?.products?.edges;
    const allLabels = document.querySelectorAll('label');
    const labelsToFill = Array.from(allLabels).filter(label => label.textContent.includes("_serviceId"));
    const serviceIdInput = labelsToFill.find(label => label.innerHTML==="_serviceId")?.nextElementSibling;
    const priceContainer = document.querySelector('.product-price .price-value');
    const priceCurrency = priceContainer?.textContent.trim().split('0').at(-1);
    let variantName = null;
    products.forEach(product => {
      if(product.node?.title === titleProduct) {
        product.node?.variants?.edges?.forEach(variant => {
          if(variant.node.id.includes(variantId)) {
            serviceIdInput.value = variant.node.metafield?.value;
            variantName = variant.node.title;
            console.log("variantName = ", variantName)
            const priceValue = parseFloat(variant.node.priceV2.amount).toLocaleString('default', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            priceContainer.innerHTML = `${priceValue} ${priceCurrency}`;
          }
        });
        product.node?.centersList?.references?.edges?.forEach(center => {
          const spaNameField = center.node.fields.find(field => field.key === "nom_du_spa");
          if (spaNameField && variantName.includes(spaNameField.value)) {
            const centerIdField = center.node.fields.find(field => field.key === "id_center");
            if (centerIdField) {
              const centerIdInput = document.querySelector('input[name="properties[_centerId]"]');
              centerIdInput.value = `${centerIdField.value}${isProduction ? "" : "-TR"}`;
            }
          }
        })
      }
    });
  }).catch(error => console.error("Error fetching shopify data:", error));
 }

function invitationCadeau() {
  const root = document.querySelector('.template-product-invitation-cadeau');
  if(root === null) return;
  const fields = root.querySelectorAll(
    '.block-item-line-item-property, .block-item-buy-buttons, .block-item-line-item-property + .block-item-separator, .block-item-line-item-property + .block-item-separator + .block-item-text, .block-item-spa-variant-picker + .block-item-separator, .block-item-spa-variant-picker + .block-item-separator + .block-item-text, .block-item-separator + .block-item-text  + .block-item-text'
  );
  const buyButtonContainers = root.querySelectorAll('.block-item-buy-buttons');
  const selectSpa = root.querySelector('.select-spa');
  const step2Checkboxes = document.querySelectorAll('[data-step="2"] input[type="radio"]');
  const step3Checkboxes = document.querySelectorAll('[data-step="3"] input[type="radio"]');
  const form = root.querySelector(
    "form[action^='/cart/add']"
  );
  const allLabels = document.querySelectorAll('label');
  const labelsToFill = Array.from(allLabels).filter(label => label.textContent.includes("_centerId"));
  const centerIdInput = labelsToFill.find(label => label.innerHTML==="_centerId")?.nextElementSibling;

  // Helpers
  const hideFields = () => {
    fields.forEach((field) => (field.style.display = 'none'));
  };
  const showFields = () => {
    fields.forEach((field) => (field.style.display = 'block'));
  };
  // --- Validation check ---
  const updateVisibility = async() => {
    const spaSelected = selectSpa.querySelector('span').textContent;
    const step2Checked = document.querySelector('.step-2').classList.contains('checked');
    const step3Checked = step3Checkboxes.length > 0 ? document.querySelector('.step-3').classList.contains('checked') : true;
    if (spaSelected && step2Checked && step3Checked) {
      const titleProduct = document.querySelector('.product-title').textContent.trim();
      const titleSpa = spaSelected;
      const option1 = document.querySelector('[data-step="2"] input[type="radio"]:checked')?.nextElementSibling?.textContent.trim();
      const option2 = document.querySelector('[data-step="3"] input[type="radio"]:checked')?.nextElementSibling?.textContent.trim();
      showFields();
      document.querySelector('.product-price')?.classList.add('active');
      // getServiceIdFromShopify(titleProduct, titleSpa, option1, option2);
      centerIdInput.value = `${selectSpa.value}${isProduction ? "" : "-TR"}`;  //TODO: remove -TR for production
    } else {
      hideFields();
    }
  };

  // --- Init: Hide everything ---
  hideFields();

  // --- Run on page load (browser restore case) ---
  updateVisibility();

  // --- Buy button starts disabled ---
  buyButtonContainers.forEach((buttonContainer) => {
    // buttonContainer.querySelector('button').disabled = true;
  });

  // --- Event listeners ---
  if (selectSpa) {
    selectSpa.addEventListener('change', updateVisibility);
  }
  const productForm = document.querySelector('.shopify-product-form')
  const titleProduct = document.querySelector('.product-title').textContent.trim();
  productForm.addEventListener('variant:change', (e) => {
    updateVisibility()
    if(e.detail.variant) {
      getServiceIdFromShopify(e.detail.variant.id, titleProduct)
    } else {
      document.querySelector('.product-price')?.classList.remove('active'); //reset price
    }
  })
  if(window.location.search.includes('variant')) {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get("variant");
    getServiceIdFromShopify(variantId, titleProduct)
  }
  step2Checkboxes.forEach((cb) =>
    cb.addEventListener('change', updateVisibility)
  );

  step3Checkboxes.forEach((cb) =>
    cb.addEventListener('change', updateVisibility)
  );

  // --- Enable buy button when required fields are filled ---
  const requiredFields = document.querySelectorAll('.product-info__block-item [required]');
  const submitButton = document.querySelector(".buy-buttons button[type='submit']");

  const checkRequiredFields = () =>{
    let allValid = true;
    requiredFields.forEach((field) => {
      if (!field.value.trim()) {
        allValid = false;
      }
    });
    // submitButton.disabled = !allValid;
  }

  requiredFields.forEach((field) => {
    field.addEventListener('input', checkRequiredFields);
    field.addEventListener('change', checkRequiredFields);
  });

  // Initial check (important if browser auto-fills values)
  checkRequiredFields();

  // --- Intercept submit to ensure properties are present ---
  submitButton.addEventListener('click', function (e) {
    // if(submitButton.disabled){
    //   return;
    // }
    // collect properties
    //hiddenInputSpa.value = selectSpa.options[selectSpa.selectedIndex].text;
    document.querySelectorAll("[name^='properties']").forEach((field) => {
      const name = field.getAttribute('name'); // keep the full properties[...] format
      const shouldInclude =
        (field.type === 'radio' && field.checked) ||
        (field.type !== 'radio' && field.value.trim() !== "");

      if (shouldInclude) {
        // check if already injected inside form
        let hiddenInput = form?.querySelector(`input[type="hidden"][name="${name}"]`);
        if (!hiddenInput) {
          console.log('no hidden input found, creating one');
          hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = name.replace('*', '').trim(); // use full name with properties[...]
          form?.appendChild(hiddenInput);
        }
        if(field.type === 'radio'){
          hiddenInput.value = field.nextElementSibling?.textContent || '';
        } else {
          hiddenInput.value = field.value.trim();
        }
      }
    });
    // let inputCurrentDate = document.querySelector('input[type="hidden"][name="properties[currentDate]"]');
    // if(!inputCurrentDate) {
    //   inputCurrentDate = document.createElement("input");
    //   inputCurrentDate.type = "hidden";
    //   inputCurrentDate.name = 'properties[currentDate]';
    //   const currentDate = new Date();
    //   inputCurrentDate.value = currentDate;
    //   form.appendChild(inputCurrentDate);
    //   console.log(currentDate);
    // } else {
    //   inputCurrentDate.value = new Date();
    //   console.log('change value '+new Date());
    // }
  });
}

document.addEventListener('DOMContentLoaded', () => invitationCadeau());

const getPmsGiftcardData = () =>{
  const payload = JSON.stringify({
    query: `query GetGiftcardVisuals($language: LanguageCode) @inContext(language: $language) {
      metaobjects(type:"giftcard_pms_visuals", first:100) {
        edges {
          node {
            type
            fields {
              key
              value
              reference {
                ... on MediaImage {
                  id
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
      }
    }`,
    variables: {
      language: document.documentElement.lang.toUpperCase(),
    }
  });

  fetch(window.themeVariables.environment.variables.graphql_url,
    {
      method: 'POST',
      body: payload,
      headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.themeVariables.environment.variables.shopify_storefront_token,
      },
    }
  ).then(response => response.json())
  .then(data => {
    fillSelectOptions(data.data?.metaobjects?.edges);
  }).catch(error => console.error("Error fetching shopify center data:", error));
};

const fillSelectOptions = (metaobjects) => {
  const select = document.querySelector('.product-info .block-item-line-item-property .select');
  // Clear all existing options
  select.querySelectorAll('option').forEach(option => option.remove());
  if(!select) return;

  // Fill first option from product visual
  // const productVisualContainer = document.querySelector('.product-gallery .product-gallery__media');

  // if(productVisualContainer?.getAttribute('data-pms-label')) {
  //   const dataInput = {
  //     label: productVisualContainer?.getAttribute('data-pms-label'),
  //     occasionId : productVisualContainer?.getAttribute('data-pms-occasion-id'),
  //     visualId : productVisualContainer?.getAttribute('data-pms-visual-id'),
  //     image: productVisualContainer?.getAttribute('data-pms-img'),
  //   };
  //   const option = document.createElement('option');

  //   option.value = dataInput.label;
  //   option.textContent = dataInput.label;
  //   option.setAttribute('data-value', JSON.stringify(dataInput));
  //   select.appendChild(option);
  // }

  // Fill options from giftcard_pms_visuals metaobject
  const templateGiftInvitation = document.querySelector('.template-product-invitation-cadeau');
  const templateGiftCard = document.querySelector('.template-product-page-carte-cadeau');

  metaobjects.forEach(edge => {
    const node = edge.node;

    const giftCardType = node.fields.find(field => field.key === 'gift_card_type')?.value;

    if ((templateGiftInvitation && giftCardType === 'Invitation') ||
        (templateGiftCard && giftCardType === 'Amount')) {

      const labelInput = node.fields.find(field => field.key === 'label')?.value;
      const dataInput = {
        label: labelInput,
        occasionId: node.fields.find(field => field.key === 'pms_occasion_id')?.value,
        visualId: node.fields.find(field => field.key === 'pms_visual_id')?.value,
        image: node.fields.find(field => field.key === 'web_visual')?.reference?.image?.url,
      };

      const option = document.createElement('option');
      option.value = labelInput;
      option.textContent = labelInput;
      option.setAttribute('data-value', JSON.stringify(dataInput));

      select.appendChild(option);
    }
  });

  // Force update of hidden inputs
  const firstOptionData = JSON.parse(select.selectedOptions[0].dataset.value) || null;
  fillValuePmsInput(JSON.stringify(firstOptionData));

  // Update visual on select change
  select.addEventListener('change', (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const data = selectedOption.dataset.value ? JSON.parse(selectedOption.dataset.value) : null;
    const imageData = data?.image?.split('/')?.at(-1)?.split('?')[0];
    const imageElement = document.querySelectorAll(`img[src*="${imageData}"]`);
    const desktopImageContainer = imageElement[0]?.closest('.product-gallery__media');
    const mobileImageContainer = imageElement[1]?.closest('button');
    const desktopGallery = document.querySelector('.product-gallery__carousel');

    fillValuePmsInput(JSON.stringify(data));

    if(window.innerWidth < 1000) {
      mobileImageContainer?.click();
    } else {
      if(desktopImageContainer && desktopGallery) {
        desktopGallery.prepend(desktopImageContainer);
        const newDesktopGallery = document.querySelector('.product-gallery__carousel');
        const newImgsWrappers = newDesktopGallery.querySelectorAll('.product-gallery__media');
        for(let i= 0; i < newImgsWrappers.length; i++) {
          const aria = newImgsWrappers[i].getAttribute("aria-label");

          const regex = /^(.*?)(\d+)(\D+)(\d+)$/;
          const match = aria.match(regex);

          if (match) {
            const [, prefix, , separator, total] = match;

            const newLabel = `${prefix}${i + 1}${separator}${total}`;
            newImgsWrappers[i].setAttribute("aria-label", newLabel);
          }
          const openLightboxButton = newImgsWrappers[i].querySelector('open-lightbox-button');
          openLightboxButton.setAttribute('image-index', i)
        }
        document.dispatchEvent(new Event("variant:change"));
      }
    }
  });
};

const fillValuePmsInput = (data) => {
  const allLabels = document.querySelectorAll('label');
  const pmsLabels = Array.from(allLabels).filter(label => label.textContent?.includes("_pmsOccasionId") || label.textContent?.includes("_pmsVisualId") || label.textContent?.includes("_giftcard"));
  const cartVisualLabel = document.querySelector('.block-item-liquid + .block-item-line-item-property label');
  const pmsOccasionInput = pmsLabels.find(label => label.innerHTML==="_pmsOccasionId").nextElementSibling;
  const pmsVisualInput = pmsLabels.find(label => label.innerHTML==="_pmsVisualId").nextElementSibling;
  const giftcardInput = pmsLabels.find(label => label.innerHTML==="_giftcard").nextElementSibling;
  const cardVisualInput = cartVisualLabel?.nextElementSibling;

  if(pmsOccasionInput && pmsVisualInput && giftcardInput && cardVisualInput) {
    const parsedData = data ? JSON.parse(data) : null;
    pmsOccasionInput.value = parsedData ? parsedData.occasionId : "";
    pmsVisualInput.value = parsedData ? parsedData.visualId : "";
    giftcardInput.value = "true";
    cardVisualInput.value = parsedData ? parsedData.label : "";
  }
};

const hideInputPms = () => {
  const allLabels = document.querySelectorAll('label');
  const pmsLabels = Array.from(allLabels).filter(label =>
    label.textContent.includes("_pmsOccasionId") ||
    label.textContent?.includes("_pmsVisualId") ||
    label.textContent.includes("_message") ||
    label.textContent.includes("_recipientName") ||
    label.textContent.includes("_recipientMail") ||
    label.textContent.includes("_scheduledTime") ||
    label.textContent.includes("_centerId") ||
    label.textContent.includes("_serviceId") ||
    label.textContent.includes("_giftcard")
  );
  const cartLineItem = document.querySelectorAll('.block-item-liquid + .block-item-line-item-property, .block-item-liquid + .block-item-line-item-property + .block-item-line-item-property');
  pmsLabels.forEach(label => {
    label.closest('.product-info__block-item').classList.add('hidden');
    label.closest('.product-info__block-item').setAttribute('aria-hidden', 'true');
  });
  cartLineItem.forEach(item => {
    item.classList.add('hidden');
    item.setAttribute('aria-hidden', 'true');
  });
};

const copyDataInput = () => {
  const allInputs = document.querySelectorAll('.product-info .product-info__block-item[data-block-type="line-item-property"]');
  const allLabels = document.querySelectorAll('label');
  const pmsLabels = Array.from(allLabels).filter(label =>
    label.textContent.includes("_message") ||
    label.textContent.includes("_recipientName") ||
    label.textContent.includes("_recipientMail") ||
    label.textContent.includes("_scheduledTime")
  );
  const cartGuestLabel = document.querySelector('.block-item-liquid + .block-item-line-item-property + .block-item-line-item-property label');
  const messageInput = allInputs[2]?.querySelector('textarea');
  const recipientNameInput = allInputs[1]?.querySelector('input');
  const recipientMailInput = allInputs[3]?.querySelector('input');
  const scheduledTimeInput = allInputs[4]?.querySelector('input');
  const pmsMessageInput = pmsLabels.find(label => label.innerHTML==="_message").nextElementSibling;
  const pmsRecipientNameInput = pmsLabels.find(label => label.innerHTML==="_recipientName").nextElementSibling;
  const pmsRecipientMailInput = pmsLabels.find(label => label.innerHTML==="_recipientMail").nextElementSibling;
  const pmsScheduledTimeInput = pmsLabels.find(label => label.innerHTML==="_scheduledTime").nextElementSibling;
  const cartGuestInput = cartGuestLabel?.nextElementSibling;

  if(messageInput && pmsMessageInput) {
    messageInput.addEventListener('input', (e) => {
      pmsMessageInput.value = e.target.value;
    });
  }
  if(recipientNameInput && pmsRecipientNameInput && cartGuestInput) {
    recipientNameInput.addEventListener('input', (e) => {
      pmsRecipientNameInput.value = e.target.value;
      cartGuestInput.value = e.target.value;
    });
  }
  if(recipientMailInput && pmsRecipientMailInput) {
    recipientMailInput.addEventListener('input', (e) => {
      pmsRecipientMailInput.value = e.target.value;
    });
  }
  if(scheduledTimeInput && pmsScheduledTimeInput) {
    scheduledTimeInput.addEventListener('input', (e) => {
      pmsScheduledTimeInput.value = e.target.value;
    });
  }
};
const checkEmailField = () => {
  const emailInput = document.querySelector('.product-info .product-info__block-item input[type="email"]');
  const emailPattern = /^[\p{L}0-9._%+-]+@[\p{L}0-9.-]+\.[\p{L}]{2,}$/u;
  if(!emailInput) return;
  emailInput.addEventListener('blur', (e) => {
    if (!emailPattern.test(emailInput.value)) {
      emailInput.classList.add('invalid');
    } else {
      emailInput.classList.remove('invalid');
    }
  });
  emailInput.addEventListener('input', (e) => {
    if(emailInput.classList.contains('invalid')) {
      emailInput.classList.remove('invalid');
    }
  });
}
const validateInputDate = () => {
  const dateInput = document.querySelector('.product-info .product-info__block-item input[type="date"]');
  if(!dateInput) return;
  const today = new Date().toISOString().split('T')[0];
  dateInput.setAttribute('min', today);
  dateInput.addEventListener('input', () => {
    const selectedDate = new Date(dateInput.value);
    const minDate = new Date(dateInput.min);

    if (selectedDate < minDate) {
      dateInput.classList.add('invalid');
    } else {
      dateInput.classList.remove('invalid');
    }

    if (!isNaN(selectedDate.getTime())) {
      dateInput.classList.add('filled');
    } else {
      dateInput.classList.remove('filled');
    }
  });
};
const setMaxInputDate = () => {
  const dateInput = document.querySelector('.product-info .product-info__block-item input[type="date"]');
  if(!dateInput) return;

  const newDate = new Date();
  newDate.setFullYear(newDate.getFullYear() + 1);
  const maxDate = newDate.toISOString().split('T')[0];
  dateInput.setAttribute('max', maxDate);
};
const hideLinePropertiesFromCart = () => {
  const allLabels = document.querySelectorAll('.product-info .product-info__block-item[data-block-type="line-item-property"] label');
  const labelsToHide = Array.from(allLabels).filter(label =>
    label.textContent.includes("_ ")
  );

  labelsToHide.forEach(label => {
    const labelText = label.innerHTML;
    const updatedText = labelText.replace(/(_ )/g, '<span class="hidden">$1</span>');
    label.innerHTML = updatedText;
  });
};

const focusErrorField = () => {
  const inputs = document.querySelectorAll('.product-info select, .product-info input');
  inputs.forEach((input) => {
    input.addEventListener('focus', function (e) {
      e.target.scrollIntoView({
        alignToTop: true,
        behavior: "smooth"
      });
    })
  })
};

document.addEventListener('DOMContentLoaded', () => {
  if(document.body.classList.contains('template-product-page-carte-cadeau') || document.body.classList.contains('template-product-invitation-cadeau')) {
    getPmsGiftcardData();
    hideInputPms();
    copyDataInput();
    checkEmailField();
    validateInputDate();
    setMaxInputDate();
    hideLinePropertiesFromCart();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  function onMonkReady(callback) {
    if (window.IsMrAppEmbed) {
      callback();
      return;
    }

    const interval = setInterval(() => {
      if (window.IsMrAppEmbed) {
        clearInterval(interval);
        callback();
      }
    }, 200);
  }
  onMonkReady(() => {
    document.body.classList.add('monk-loaded');
  });
});
const removeFilterByService = () => {
  const filters = document.querySelector('.template-collection-offrir-un-soin #facets-drawer-form');
  const filterToHide = filters.querySelector('.custom-case');
  filterToHide?.remove();
};

document.addEventListener('DOMContentLoaded', () => {
  if(document.body.classList.contains('template-collection-offrir-un-soin')) {
    removeFilterByService();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  window.dataLayer = window.dataLayer || [];
  const newsletterForm = document.querySelector('form[action^="/contact#newsletter-form"]');
  newsletterForm?.addEventListener('submit', () => {
    const emailInput = newsletterForm.querySelector('input[name="contact[email]"]');
    const emailValue = emailInput ? emailInput.value.trim() : '';
    sessionStorage.setItem('newsletter_suscription', emailValue);
  });
  if(window.location.search.includes('customer_posted=true')){
    window.dataLayer.push({
      "event": "newsletter-success",
      "user_email": sessionStorage.getItem('newsletter_suscription')
    });
    sessionStorage.removeItem('newsletter_suscription');
  } else {
    if (window.location.pathname === '/account/register') {
      const registerForm = document.querySelector('form#create_customer');
      registerForm?.addEventListener('submit', () => {
        sessionStorage.setItem('account_creation_attempt', 'true');
      });
    }
    if (sessionStorage.getItem('account_creation_attempt')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "event": 'account-creation-success',
        "user_email": window.pageData.user_email
      });
      sessionStorage.removeItem('account_creation_attempt');
    } else {
      window.dataLayer.push({
        "event": "datalayer-loaded",
        "page_type": window.pageData.page_type,
        "arbo": window.pageData.arbo,
        "breadcrumb": window.pageData.breadcrumb,
        "product_id": window.pageData.product_id,
        "product_name": window.pageData.product_name,
        "product_category": window.pageData.product_category,
        "product_brand": window.pageData.product_brand,
        "product_price_ati": window.pageData.product_price_ati,
        "product_price_tf": window.pageData.product_price_tf,
        "user_id": window.pageData.user_id,
        "user_email": window.pageData.user_email,
        "user_firstname": window.pageData.user_firstname,
        "user_lastname": window.pageData.user_lastname,
        "user_street": window.pageData.user_street,
        "user_city": window.pageData.user_city,
        "user_region": window.pageData.user_region,
        "user_country": window.pageData.user_country,
        "user_zipcode": window.pageData.user_zipcode
      });
    }
  }

});
const validationResetPasswordForm = () => {
  const passwordInput = document.querySelectorAll('input[type="password"]')?.[0];
  const confirmPasswordInput = document.querySelectorAll('input[type="password"]')?.[1];
  const submitButton = document.querySelector('button[type="submit"]');
  const errorMessage = document.querySelector('.custom-errors');

  const hideErrorMessage = () => {
    errorMessage.classList.remove('active');
    errorMessage.setAttribute('aria-hidden', 'true');
  }

  submitButton.addEventListener('click', (e) => {
    if(passwordInput?.value !== confirmPasswordInput?.value &&
      passwordInput?.value.length >=5 &&
      confirmPasswordInput?.value.length >=5) {
      e.preventDefault();
      errorMessage.classList.add('active');
      errorMessage.setAttribute('aria-hidden', 'false');
    }
  });

  passwordInput?.addEventListener('input', () => {
    hideErrorMessage();
  });

  confirmPasswordInput?.addEventListener('input', () => {
    hideErrorMessage();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if(document.body.classList.contains('template-customers-reset_password')) {
    validationResetPasswordForm();
  }
});

window.addEventListener('message', (e) => {
  if (e.data && e.data.event === 'contact-form-success') {
    window.dataLayer = window.dataLayer || [];
    const formId = document.querySelector('.pxFormGenerator')?.id || '';
    window.dataLayer.push({
      event: 'contact-form-success',
      user_email: e.data.email,
      form_id: formId
    });
    console.log('Received form submission via postMessage:', e.data.email);
  }
});
/** START : CUSTOMER ACCOUNT BACK BUTTON FOR MY INFORMATION **/
document.addEventListener('DOMContentLoaded', function() {
  const target = document.querySelector('.cf-form-section.customer #cf-edit-account-back-link');

  if (target) {
    const backLabel = target.innerHTML.replace('← ', '');
    const backURI = target.attributes['href'].value;
    target.insertAdjacentHTML('afterend',`
<a href="${backURI}" style="position: relative;" class="customer-account__back-button group:circle-button h-stack gap-3">
  <span class="circle-button"><svg aria-hidden="true" focusable="false" width="10" class="icon icon-big-arrow-left  icon--direction-aware" part="icon" viewBox="0 0 36 36">
    <path fill="none" stroke="currentColor" stroke-width="2" d="M35 18H3M19.5 34.5 3 18 19.5 1.5"></path>
  </svg></span>
  <span class="subheading">${backLabel}</span>
</a>
    `);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.collection-quick-navigation.scroll-area');
  const prevBtn = document.querySelector('.collection-quick-navigation-arrow.previous');
  const nextBtn = document.querySelector('.collection-quick-navigation-arrow.next');
  const scrollAmount = 100;

  if (wrapper && prevBtn && nextBtn) {
    // Scroll selected item into view on load
    const selectedItem = wrapper.querySelector('.collection-quick-navigation__item.is-selected');
    selectedItem?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });

    // Check if content overflows and toggle scrollable class
    const checkOverflow = () => {
      const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.parentElement?.classList.toggle('is-scrollable', isScrollable);
    };

    // Update arrow button states based on scroll position
    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = wrapper;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    };

    prevBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    wrapper.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', () => {
      updateArrows();
      checkOverflow();
    });

    checkOverflow();
    updateArrows();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.shopify-section--products-with-image')) {
    const emptyGeneratedLinks = document.querySelectorAll('.shopify-section--products-with-image a:not([href])');
    // remove extra generated a tags that broke the layout
    emptyGeneratedLinks.forEach(link => {
      const innerContent = link.innerHTML;
      link.outerHTML = innerContent;
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const inputCities = document.querySelectorAll('select[name="address[country]"]');
  inputCities.forEach(input => {
    const defaultOption = input.querySelector('option[value="---"]');
    if(defaultOption) {
      defaultOption.setAttribute('value', '');
      defaultOption.textContent = '';
    }
  });
});

const reformatGiftcardLinkUrl = () => {
  const currentUrl = new URL(window.location.href);
  const giftcardLinkUrl = document.querySelector(".block-item-button + .block-item-button a").href;

  if (giftcardLinkUrl) {
    const url = new URL(giftcardLinkUrl);
    const newGiftcardLinkUrl = currentUrl.origin + url.pathname + url.search;
    document.querySelector(".block-item-button + .block-item-button a").href = newGiftcardLinkUrl.toString();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.product-info .block-item-button + .block-item-button')) {
    reformatGiftcardLinkUrl();
  }
});

// cart-drawer
// this is a workaround for the janky behavior caused by monk
// we disable the drawer when the cart changes and start a timer to re-enable it
// the delay values are set arbitrarily via trial and error
const disableCartDrawer = (delay) => {
  window.cartIsBusy = delay
  if (window.disableCartDrawerTimer) {
    window.clearTimeout(window.disableCartDrawerTimer);
    window.disableCartDrawerTimer = null;
  }

  const drawer = document.querySelector("#cart-drawer");

  if (typeof drawer !== "undefined") {
    drawer.classList.add("disabled");
    window.disableCartDrawerTimer = window.setTimeout(() => {
      const isCartChanged = localStorage.getItem("isCartChanged");
      if(isCartChanged){
        enableCartDrawer(true);
      } else {
        enableCartDrawer(false);
      }
    }, delay);
  }
}

const enableCartDrawer = (isCartReady) => {
  const drawer = document.querySelector("#cart-drawer");

  if (typeof drawer !== "undefined") {
    drawer.classList.remove("disabled");
    if(isCartReady){
      document.dispatchEvent(new Event("cart:drawerReady"));
    }
  }
  window.cartIsBusy = false;
}

window.addEventListener("cart:change", () => {
  localStorage.setItem("isCartChanged", "true");
  disableCartDrawer(3000);
}, true);

window.addEventListener("cart:refresh", () => {
  disableCartDrawer(2000);
}, true);

window.addEventListener("mr:cartTotalUpdate", () => {
  disableCartDrawer(500);
}, true);

window.addEventListener("click", (event) => {
  // cart drawer opened
  // and button pressed is not checkout
  if(
    document.querySelector("body > cart-drawer")
    && event.target.parentNode.name !== "checkout"
  ){
    if(window.cartIsBusy) {
      event.preventDefault();
      event.stopPropagation();
      disableCartDrawer(window.cartIsBusy);
    }
    else {
      disableCartDrawer(2000);
    }
  }
}, true);


const giftPage = (formGift) => {
  if(!formGift) return;

  const btnSubmit = formGift.querySelector('.buy-buttons button[type="submit"]')
  if (!btnSubmit) return;

  const handleSubmit = () => {
    let inputCurrentDate = formGift.querySelector('input[type="hidden"][name="properties[_currentDate]"]');
    if(!inputCurrentDate) {
      inputCurrentDate = document.createElement("input");
      inputCurrentDate.type = "hidden";
      inputCurrentDate.name = 'properties[_currentDate]';
      const currentDate = new Date();
      inputCurrentDate.value = currentDate;
      formGift.appendChild(inputCurrentDate);
      console.log(currentDate);
    } else {
      inputCurrentDate.value = new Date();
      console.log('change value '+new Date());
    }
    formGift.appendChild(inputCurrentDate);
    // make sure the viewport is scrolled to show the first input with error
    focusErrorField();
  }
  btnSubmit.removeEventListener('click', handleSubmit);
  btnSubmit.addEventListener('click', handleSubmit);
}
const root = document.querySelector('.template-product-page-carte-cadeau, .template-product-invitation-cadeau');
if(root) {
  const locale = document.documentElement.lang || "";
  const formGift = locale === "fr" ? root.querySelector("form[action^='/cart/add']") : root.querySelector(`form[action^='/${locale}/cart/add']`);
  formGift.addEventListener('product:rerender', () => giftPage(formGift));
  document.addEventListener('DOMContentLoaded', () => giftPage(formGift));
}

const displayPasswordResetSuccess = () => {
  if(window.location.pathname.includes('account')) {
    const accountInner = document.querySelector('.customer-account__inner');
    if(accountInner) {
      const bannerSuccess = accountInner.querySelector('.banner--success.hidden')
      if(bannerSuccess) {
        if(window.location.search.includes('password_reset=success')) {
          bannerSuccess.classList.remove('hidden');
        } else {
          bannerSuccess.classList.add('hidden');
        }
      }
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  displayPasswordResetSuccess();
});

const displayHeaderOnTop = () => {
  const header = document.querySelector('.header');
  if(!header) return;

  const checkScroll = () => {
    if(window.scrollY === 0) {
      header.classList.remove('is-hidden');
      header.classList.add('force-top');
    } else {
      header.classList.remove('force-top');
    }
  };

  checkScroll();
  window.addEventListener('scroll', checkScroll);
};

document.addEventListener('DOMContentLoaded', () => {
  displayHeaderOnTop();
});
